import HistoryImg from "../../Assetes/Images/history-img.png"
import BasketArrow from "../../Assetes/Images/arrow-basket.png"
import FactOne from "../../Assetes/Images/fact-1.png"
import FactTow from "../../Assetes/Images/fact-2.png"
import FactThree from "../../Assetes/Images/fact-3.png"
import FactFour from "../../Assetes/Images/fact-4.png"
import MitaoBhook from "../../Assetes/Images/mitaobhook_new.png"
import Citizen from "../../Assetes/Images/citizen.png"
import Cyte from "../../Assetes/Images/cyte.png"
import Orange from "../../Assetes/Images/orange.png"
import Deaf from "../../Assetes/Images/deaf.jpeg"
import { useEffect } from "react"
import Footer from "../../Components/Footer"
import Header from "../../Components/Header"
import useTheme from "../../MobileAppUrl/UseTheme"
import useDarkTheme from "../../MobileAppUrl/UseDarkTheme"
import GoBack from "../BackButton/GoBack"
import { useTranslation } from "react-i18next"

export default function AboutUs(props: any) {
    const { t } = useTranslation();
    const { darktheme, toggleDarkTheme } = useDarkTheme();
    const { theme, toggleTheme } = useTheme();

    useEffect(() => {
        const { theme } = props.match.params;

        if (theme === undefined) {
            localStorage.removeItem("theme");
            return;
        }
        if (theme === "night") {
            toggleDarkTheme();
            return;
        }
        if (theme === "day") {
            toggleTheme();
            return;
        }
    }, [props.match.params]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Header />
            <section >
                <div className="container">
                    <div className="about-us position-relative">
                        <div className="back-btn-position web-backbtn">
                            <GoBack />
                        </div>
                        <h2 className="about-title text-uppercase">{t("ABOUT_US_TITLE")}</h2>
                        {/* <div className="about-kfc">
                            <div className="row">

                                <div className="col-lg-7 col-md-6">
                                    <p>  KFC entered Pakistan in 1997 and since then, it’s been a 
                                        journey full of excitement and Finger Lickin’ goodness! The 
                                        first KFC restaurant opened in Pakistan opened in Gulshan Iqbal,
                                         Karachi and now our Finger Lickin’ Chicken is available in 38 
                                         cities with over 133 restaurants! Being the most loved fast food 
                                         chain in Pakistan, KFC leaves no stone unturned to provide its 
                                         customers the most delicious chicken and an excellent dining experience.
                                    </p>
                                </div>
                                <div className="col-lg-5  col-md-6">
                                    <h4 className='kfc-quality'>
                                        WE PRIDE OURSELVES ON USING QUALITY HALAL CHICKEN AND
                                        LOCAL INGREDIENTS FROM TRUSTED SUPPLIERS
                                    </h4>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
            <section>
                <div className="container">
                    <div className="about-kfc mt-5">
                        <div className="row">


                            <div className="col-md-12">
                                <div className="about-history">
                                    {/* <h4>{t("ABOUT_US_HEADING")}
                                    </h4> */}
                                    <p>{t("ABOUT_US_P1")}</p>
                                    <p>{t("ABOUT_US_P2")}</p>
                                    <p>{t("ABOUT_US_P3")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section>
                <div className="container">
                    <h2 className="aboutus-title mt-7 mb-3">The Story of World’s Best Chicken</h2>
                    <div className="about-chicken">
                        <div className="aboutus-basket">
                            <span>
                                <h3>1890</h3>
                                <p>Harland Sanders was born</p>
                            </span>
                        </div>
                        <div>
                            <img className="basket-error" src={BasketArrow} alt="" />
                        </div>
                        <div className="aboutus-basket">
                            <span>
                                <h3>1930</h3>
                                <p>Sanders Court & Cafe was opened in front of his gas station in Corbin Kentucky</p>
                            </span>
                        </div>
                        <div>
                            <img className="basket-error" src={BasketArrow} alt="" />
                        </div>
                        <div className="aboutus-basket">
                            <span>
                                <h3>1940</h3>
                                <p>Colonel Sanders develops the Original Recipe from 11 secret herbs and spices</p>
                            </span>
                        </div>
                        <div>
                            <img className="basket-error" src={BasketArrow} alt="" />
                        </div>
                        <div className="aboutus-basket">
                            <span>
                                <h3>1952</h3>
                                <p>The Colonel begins franchising his business travelling from town to town and cooking for restaurant owners</p>
                            </span>
                        </div>
                        <div>
                            <img className="basket-error" src={BasketArrow} alt="" />
                        </div>
                        <div className="aboutus-basket">
                            <span>
                                <h3>1957</h3>
                                <p>Kentucky Fried Chicken is first sold in buckets</p>
                            </span>
                        </div>
                        <div>
                            <img className="basket-error" src={BasketArrow} alt="" />
                        </div>
                        <div className="aboutus-basket">
                            <span>
                                <h3>1964</h3>
                                <p>More than 600 franchised outlets in the USA, Canda and UK</p>
                            </span>
                        </div>
                        <div>
                            <img className="basket-error" src={BasketArrow} alt="" />
                        </div>
                        <div className="aboutus-basket">
                            <span>
                                <h3>1974</h3>
                                <p>KFC first launches in Kuwait</p>
                            </span>
                        </div>
                        <div>
                            <img className="basket-error" src={BasketArrow} alt="" />
                        </div>
                        <div className="aboutus-basket">
                            <span>
                                <h3>1980</h3>
                                <p>Colonel Sanders passes away at the age of 90. His legacy lives on.</p>
                            </span>
                        </div>
                        <div>
                            <img className="basket-error" src={BasketArrow} alt="" />
                        </div>
                        <div className="aboutus-basket">
                            <span>
                                <h3>Today</h3>
                                <p>
                                    Today we have more than 25,000 KFC restaurants in over 145 countries and territories around the world.
                                </p>
                            </span>
                        </div>


                    </div>

                </div>
            </section> */}
            {/* <section className="kfc-pakistan">
                <div className="container">
                    <h2 className="aboutus-title mb-3">Fast Facts about KFC Pakistan</h2>
                    <div className="row">
                        <div className="col-lg-3 col-md-6 mt-3">
                            <div className="about-facts">
                                <div>
                                    <img src={FactOne} alt="FactOne" />
                                    <h3>1997</h3>
                                    <p className="aboutus-p">
                                        The first KFC restaurant in Pakistan opened in 1997 and was located in Gulshan-e-Iqbal Karachi.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt-3">
                            <div className="about-facts">
                                <div>
                                    <img src={FactTow} alt="FactOne" />
                                    <h3>133</h3>
                                    <p className="aboutus-p">
                                        Today KFC has grown to over 133 restaurants across the country
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt-3">
                            <div className="about-facts">
                                <div>
                                    <img src={FactThree} alt="FactOne" />
                                    <h3>9</h3>
                                    <p className="aboutus-p">
                                        Giving back to the community, KFC runs 9 restaurants operated by deaf,
                                        Hearing With Heart team members
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt-3">
                            <div className="about-facts">
                                <div>
                                    <img src={FactFour} alt="FactOne" />
                                    <h3>9000+</h3>
                                    <p className="aboutus-p">
                                        Our Finger Lickin’ Chicken is brought to you by the hardwork of a team of 9000+ people across Pakistan
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            {/* <section>
                <div className="container">
                    <div className="kfc-bhook">
                        <img className="mitao-bhook" src={MitaoBhook} alt="MitaoBhook" />
                        <p>
                            is KFC’s pledge to give back to society. Over the years we have made
                            it our mission to spread the message of hope, bringing positive change
                            in the lives of people and providing better living standards.
                            Mitao Bhook strengthens the community on the pillars of Education, Inclusion & Diversity.
                        </p>
                    </div>
                </div>
            </section> */}
            {/* <section>
                <div className="container mt-md-5">
                    <div className="row">
                        <div className="col-md-6 mt-4">
                            <div className="about-institute">
                                <img src={Citizen} alt="Citizen" />
                                <p>  Adopted 6 TCF schools since 2014 in Gadaap West, Muzaffargarh, Faisalabad, and Quetta, educating 1700+ students</p>
                            </div>
                        </div>
                        <div className="col-md-6 mt-4">
                            <div className="about-institute">
                                <img className="deaf-img" src={Deaf} alt="Citizen" />
                                <p> Proudly running the Deaf Reach KFC Campus and providing education and training to 340 deaf students</p>
                            </div>
                        </div>
                        <div className="col-md-6 mt-4">
                            <div className="about-institute">
                                <img src={Orange} alt="Citizen" />
                                <p>  Sponsoring higher education of 200+ students across HEC recognized universities in Pakistan</p>
                            </div>
                        </div>
                        <div className="col-md-6 mt-4">
                            <div className="about-institute">
                                <img src={Cyte} alt="Citizen" />
                                <p>Supporting TEGS – KFC Campus to provide quality education to students in Lahore</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section> */}
            <Footer />
        </>
    )
}
